
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/flight",
      function () {
        return require("private-next-pages/[locale]/flight.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/flight"])
      });
    }
  